import { render, staticRenderFns } from "./ChargesForm.vue?vue&type=template&id=5f35ee1c&scoped=true&"
import script from "./ChargesForm.vue?vue&type=script&lang=js&"
export * from "./ChargesForm.vue?vue&type=script&lang=js&"
import style0 from "./ChargesForm.vue?vue&type=style&index=0&id=5f35ee1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35ee1c",
  null
  
)

export default component.exports